import { render, staticRenderFns } from "./PartnerRegisterCopySearch.vue?vue&type=template&id=5b11e81a&"
import script from "./PartnerRegisterCopySearch.vue?vue&type=script&lang=ts&"
export * from "./PartnerRegisterCopySearch.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports